<div
    class="card"
    *ngIf="showHeaderCard"
    [formGroup]="jobSearchForm"
>
    <div class="p-grid p-ai-center">
        <div class="p-col-12 p-md-5">
            <span class="p-input-icon-left" style="display: block;">
                <i class="pi pi-search"></i>
                <input
                    type="text"
                    #searchInput
                    pInputText
                    formControlName="search"
                    placeholder="Enter Code, Customer, Email ..."
                    class="full-width"
                    data-cy="search-text-field"
                >
            </span>
        </div>
        <div class="p-col-12 p-md-4">
            <p-multiSelect
                [options]="tags"
                formControlName="tagIds"
                placeholder="Tags"
                optionLabel="name"
                optionValue="id"
                [autofocusFilter]="!responsiveHelper.isSmallScreen"
                [appendTo]="responsiveHelper.isSmallScreen ? 'body' : null"
                data-cy="status-multi-select-field"
            >
                <ng-template pTemplate="selectedItems">
                    <span class="tag-container">
                        <ng-container *ngFor="let id of jobSearchForm.controls.tagIds.value">
                            <p-tag
                                *appVar="(tags | getObjectById : id) as tag"
                                [style]="{'background-color': tag.color}"
                                [colorForBackground]="{elementSelector: 'span', backgroundColor: tag.color}"
                            >
                                {{tag | formatTag}}
                            </p-tag>
                        </ng-container>
                    </span>
                    <span *ngIf="!jobSearchForm.controls.tagIds.value?.length">
                        Tags
                    </span>
                </ng-template>
                <ng-template
                    let-tag
                    pTemplate="item"
                >
                    <p-tag
                        [style]="{'background-color': tag.color}"
                        [colorForBackground]="{elementSelector: 'span', backgroundColor: tag.color}"
                    >
                        {{tag | formatTag}}
                    </p-tag>
                </ng-template>
            </p-multiSelect>
        </div>
        <div class="p-col-12 p-md-3 p-text-right p-d-none p-d-md-block">
            <button
                pButton
                label="Open Report"
                icon="pi pi-external-link"
                (click)="openReport()"
                class="p-button-outlined"
            ></button>
        </div>
    </div>
</div>

<div class="card">
    <p-table
        [value]="jobs"
        [loading]="jobsQH.loading"
        [showLoader]="!jobsQH.mergeNextResults && !jobsQH.isFirstLoad"
        breakpoint="620px"
    >
        <ng-template pTemplate="header">
            <tr>
                <th *ngIf="activeData.stage" style="width: 1rem">Stage</th>
                <th *ngIf="activeData.tags">Tags</th>
                <th *ngIf="activeData.state" class="p-text-center">State</th>
                <th *ngIf="activeData.code">Code</th>
                <th *ngIf="activeData.status">Status</th>
                <th *ngIf="activeData.customer">Customer</th>
                <th *ngIf="activeData.total">Total</th>
                <th *ngIf="activeData.amountDue">Amount Due</th>
                <th *ngIf="activeData.date">Created</th>
                <th *ngIf="activeData.firstBookedRevenueGeneratingEvent">Booking Date</th>
                <th *ngIf="activeData.timeline">Timeline</th>
                <th
                    *ngIf="activeData.link"
                    style="width: 3rem"
                ></th>
            </tr>
        </ng-template>
        <ng-template
            pTemplate="body"
            let-job
            let-index="rowIndex"
        >
            <tr
                class="selectable-row"
                *ngIf="!job.error"
                (appDoubleClick)="freyaHelper.openItem('job', job?.id)"
                (singleClick)="selectJob(job)"
                (auxclick)="freyaHelper.openItem('job', job?.id, true)"
            >
                <td *ngIf="activeData.stage">
                    <span class="p-column-title">Stage</span>
                    {{job.stage | titlecase}}
                </td>
                <td *ngIf="activeData.tags">
                    <span class="p-column-title">Tags</span>
                    <span>
                        <p-tag
                            *ngFor="let tag of job?.tags"
                            [style]="{'background-color': tag.color}"
                            [colorForBackground]="{elementSelector: 'span', backgroundColor: tag.color}"
                        >
                            {{tag | formatTag}}
                        </p-tag>
                    </span>
                </td>
                <td *ngIf="activeData.state" class="p-text-center">
                    <span class="p-column-title">State</span>
                    <app-object-state
                        [object]="job"
                        objectType="job"
                        [colorful]="true"
                        ></app-object-state>
                </td>
                <td *ngIf="activeData.code">
                    <span class="p-column-title">Code</span>
                    {{job.code}}
                </td>
                <td *ngIf="activeData.status">
                    <span class="p-column-title">Status</span>
                    <div class="tag-container">
                        <p-tag
                            *ngIf="job?.tags.length > 0"
                            [style]="{'background-color': job.tags[0].color}"
                        >
                            {{job.tags[0] | formatTag}}
                        </p-tag>
                        <p-tag *ngIf="job.tags.length > 1">
                            +{{job.tags.length - 1}}
                        </p-tag>
                        <span *ngIf="!job.tags || job.tags.length === 0">
                            None
                        </span>
                    </div>
                </td>
                <td *ngIf="activeData.customer">
                    <span class="p-column-title">Customer</span>
                    {{job.users | jobCustomer}}
                </td>
                <td *ngIf="activeData.total">
                    <span class="p-column-title">Total</span>
                    {{job.total / 100 | currency : job.currency}}
                </td>
                <td *ngIf="activeData.amountDue">
                    <span class="p-column-title">Amount Due</span>
                    {{job | jobAmountDue}}
                </td>
                <td *ngIf="activeData.date">
                    <span class="p-column-title">Date</span>
                    {{job.createdAt * 1000 | date : 'mediumDate'}}
                </td>
                <td *ngIf="activeData.firstBookedRevenueGeneratingEvent">
                    <span class="p-column-title">Booking Date</span>
                    <span *ngIf="job.firstBookedRevenueGeneratingEvent">
                        {{job.firstBookedRevenueGeneratingEvent * 1000 | date : 'mediumDate'}}
                    </span>
                </td>
                <td *ngIf="activeData.timeline">
                    <span class="p-column-title">Timeline</span>
                    <span *ngIf="!job.timeline"
                        [pTooltip]="formatTimelineTooltip(job.createdAt, job.timeline)"
                    ></span>
                    <span *ngIf="job.timeline"
                        class="timeline"
                        [pTooltip]="formatTimelineTooltip(job.createdAt, job.timeline)"
                    >
                        {{ formatTimeline(job.timeline) | date : 'mediumDate' }}
                        <br />
                        <small>{{ formatTimelineTooltip(job.createdAt, job.timeline) }}</small>
                    </span>
                </td>
                <td *ngIf="activeData.link" >
                    <span></span>
                    <app-open-link
                        [link]="generateLink(job.id)">
                    </app-open-link>
                </td>
            </tr>
            <tr *ngIf="job.error">
                <td colspan="6">Error Loading Job : {{job.error.message}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="loadingbody">
            <ng-container *ngFor="let placeholder of jobPlaceholderCount">
                <tr>
                    <td *ngFor="let col of jobPlaceholderColumnCount">
                        <p-skeleton
                            height="2rem"
                            width="100%"
                            ></p-skeleton>
                    </td>
                    <td
                        *ngIf="activeData.link"
                        style="width: 3rem"
                        >
                    <app-open-link [disabled]="true"></app-open-link>
                    </td>
                </tr>
            </ng-container>
        </ng-template>
        <ng-template
            pTemplate="emptymessage"
            let-car
            let-columns="columns"
        >
            <tr>
                <td [attr.colspan]="'6'">
                    {{pagination.emptyMessage}}
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="footer">
            <tr>
            </tr>
        </ng-template>
    </p-table>
    <div
        *ngIf="!jobsQH.loading && jobsQH.hasMore"
        class="p-text-center"
        (appLazyLoad)="retrieveMoreJobs()"
        >
        <span class="freya-link-button" (click)="retrieveMoreJobs()">Load more</span>
    </div>
    <div
        *ngIf="!jobsQH.loading && !jobsQH.hasMore"
        class="p-text-center"
    >
        No more jobs to show.
    </div>
</div>